export default __webpack_public_path__ + "static/BUS_3-60cdac6e59203d42e6c4cc6d35c45f5f.jpg";